export function Button({ as: Tag = 'button', variant = 'primary', size, iconRight, className = '', children, ...props }) {
  const classes = ['bs-btn', `bs-btn--${variant}`, size ? `bs-btn--${size}` : '', className].filter(Boolean).join(' ');
  return <Tag className={classes} {...props}>{children}{iconRight ? <span aria-hidden="true">{iconRight}</span> : null}</Tag>;
}

export function Card({ className = '', children, ...props }) {
  return <div className={`bs-card ${className}`.trim()} {...props}>{children}</div>;
}

export function Field({ label, hint, error, id, required, children, className = '' }) {
  const hintId = hint ? `${id}-hint` : undefined;
  const errorId = error ? `${id}-error` : undefined;
  return (
    <div className={`bs-field ${className}`.trim()}>
      <label className="bs-field__label" htmlFor={id}>{label}{required ? <span aria-hidden="true"> *</span> : null}</label>
      {hint ? <span className="bs-field__hint" id={hintId}>{hint}</span> : null}
      {typeof children === 'function' ? children({
        id,
        'aria-describedby': [hintId, errorId].filter(Boolean).join(' ') || undefined,
        'aria-invalid': error ? 'true' : undefined,
      }) : children}
      {error ? <span className="bs-field__error" id={errorId} role="alert">{error}</span> : null}
    </div>
  );
}

export function Input(props) {
  return <input className={`bs-input ${props['aria-invalid'] ? 'bs-input--error' : ''}`.trim()} {...props} />;
}

export function Textarea(props) {
  return <textarea className={`bs-input ${props['aria-invalid'] ? 'bs-input--error' : ''}`.trim()} {...props} />;
}

export function Select({ children, ...props }) {
  return <span className="bs-select-wrap"><select className={`bs-input bs-select ${props['aria-invalid'] ? 'bs-input--error' : ''}`.trim()} {...props}>{children}</select></span>;
}

export function RadioCards({ name, legend, options, value, onChange, required, error }) {
  const errorId = error ? `${name}-error` : undefined;
  return (
    <fieldset className="radio-fieldset" aria-describedby={errorId}>
      <legend className="bs-field__label">{legend}{required ? <span aria-hidden="true"> *</span> : null}</legend>
      <div className="radio-card-grid">
        {options.map((option) => {
          const item = typeof option === 'string' ? { value: option, label: option } : option;
          return (
            <label className={`radio-card ${value === item.value ? 'radio-card--selected' : ''}`} key={item.value}>
              <input type="radio" name={name} value={item.value} checked={value === item.value} onChange={onChange} required={required} />
              <span>{item.label}</span>
            </label>
          );
        })}
      </div>
      {error ? <span className="bs-field__error" id={errorId} role="alert">{error}</span> : null}
    </fieldset>
  );
}
